import ProgramSlider from "@/components/home/ProgramSlider";
import QuickMenu from "@/components/home/QuickMenu";
import NoticeSection from "@/components/home/NoticeSection";


export default function Home() {
  return (
    <div>
      <ProgramSlider />
      <QuickMenu />
      <NoticeSection />
    </div>
  );
}